// Toaster.js
import React, { useState, useEffect } from 'react';
import './Toaster.css';
import { FaTimes } from 'react-icons/fa';  // X ikonu
import { useLanguage } from '../../LanguageProvider';

const Toaster = ({ message, type, duration, onClose, position = { bottom: '20px', right: '20px' } }) => {
  const { getTranslation } = useLanguage();
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(100); // Progress bar genişliği

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev - 100 / (duration / 100)); // Her 100ms'de bir azalma
    }, 100);

    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [duration, onClose]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose();
  };

  if (!visible) return null;

  return (
    <div className={`toaster ${type}`} style={position}>
      <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',marginBottom:'10px',fontWeight:'600' }}>
        {type === "success" && getTranslation('success')}
        {type === "error" && getTranslation('error')}
        {type === "warning" && getTranslation('warning')}
        <FaTimes className={`toaster-close ${type}`} onClick={handleClose} />
      </div>
      <span style={{ alignItems: 'center', display: 'flex', fontSize: '14px', justifyContent: 'space-between', marginRight: '5px', marginBottom: '10px' }}>{message} </span>
      <div className={`toaster-progress ${type}`} style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default Toaster;
